/**
 * Єдине місце, де будується шлях короткого посилання на твір/розділ.
 *
 * Для звичайних джерел: /<джерело>/<слаг>[/chapterN]. Для "прихованого" джерела
 * (HIDDEN_PLUGIN_ID — те саме, що гість бачить як весь сайт; див. server
 * routes/pretty.ts) назва джерела в адресі не фігурує, щоб ніхто, окрім
 * користувачів із data/users.json, не знав про систему плагінів:
 *   твір   → /title/<слаг>
 *   розділ → /chapter/<слаг>/[vol<V>]chapter<M>
 */
export const HIDDEN_PLUGIN_ID = 'smakolykytl';

/** chapterSuffix — те, що повертає chapterUrlSuffix(): "/chapterM" або "/volVchapterM" (або порожньо для сторінки твору). */
export function prettyWorkPath(pluginId: string, slug: string, chapterSuffix = ''): string {
  const s = encodeURIComponent(slug);
  if (pluginId === HIDDEN_PLUGIN_ID) return chapterSuffix ? `/chapter/${s}${chapterSuffix}` : `/title/${s}`;
  return `/${encodeURIComponent(pluginId)}/${s}${chapterSuffix}`;
}

const GUEST_TAB_KEY = 'guest-catalog-tab';

/** Запам'ятовує вкладку каталогу гостя ('updates' | 'name'), з якої він пішов на сторінку твору. */
export function rememberGuestTab(tab: 'updates' | 'name'): void {
  try {
    sessionStorage.setItem(GUEST_TAB_KEY, tab);
  } catch {
    /* приватний режим тощо — не критично */
  }
}

/** Куди веде стрілка "назад" зі сторінки твору в гостя: на ту вкладку каталогу, з якої він прийшов. */
export function guestCatalogHref(): string {
  try {
    return sessionStorage.getItem(GUEST_TAB_KEY) === 'name' ? '/titles' : '/';
  } catch {
    return '/';
  }
}
